export default __webpack_public_path__ + "locales/ro/Article.json?hash=a710832d6f6c5f8cf41bffa44033b437";